module.exports = __webpack_public_path__ + "static/media/mode-46.ddc2047d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-46.svg
// module id = 1018
// module chunks = 2